<template>
  <div class="text-sm text-gray-800 space-y-1">
    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Mostrar progreso de avance de:</span>
      <span class="text-gray-900 font-semibold">{{ progressLabel() }}</span>
    </div>

    <div v-if="configPage.showGroupProgress === 'custom'" class="flex gap-x-2">
      <span class="font-medium text-gray-600">Mostrar progreso de los siguietes grupos:</span>
      <span class="text-gray-900 font-semibold">{{ groupNamesToString(configPage.customGroups) }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Primera fecha:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.settings.firstDatePairType }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Segunda fecha:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.settings.secondDatePairType }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Mostrar la fecha final, según se vayan completando las actividades:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.settings.showEndDateOnCompletion ? 'Sí' : 'No' }}</span>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Página visible:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.visible ? 'Sí' : 'No' }}</span>
    </div>
  </div>
</template>

<script>
import { getGroupNameById } from '../services/helpers.service.js';

export default {
  name: "PageSummaryConfigView",

  props: {
    configPage: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
    };
  },

  methods: {
    groupNamesToString() {
      const list = this.configPage.customGroups ?? this.configPage.settings?.customGroups;

      if (!Array.isArray(list)) return '';
      let nameGroups = list.map(item => getGroupNameById(item, this.activityGroups));

      return nameGroups.join(', ');
    },

    progressLabel() {
      const value = this.configPage.showGroupProgress ?? this.configPage.settings?.showGroupProgress ?? '';
      const labels = {
        parent: "Grupos padres",
        children: "Grupos hijos",
        custom: "Personalizado"
      };

      return labels[value] || "-";
    },
  }
}
</script>